module.exports = __webpack_public_path__ + "static/key-metalunit-12c848b7b383436813cea6a2b537696d.webp";